<template>
  <header class="global-box">
    <div class="content-box">
      <img
        src="../assets/images/logo/brand-click-gestao.svg"
        class="logo-click-gestao"
        alt="Logomarca Click Gestão"
      >
      <div class="content-header">
        <div class="content-text">
          <h1>
            Tecnologia para a gestão de seu negócio
          </h1>
          <h4>
            Desenvolvemos aplicações viáveis e simples, a um preço justo,
            que facilitem a gestão de seu negócio, dia-a-dia.
          </h4>
        </div>
        <img
        src="../assets/images/image.svg"
        class="logo-click-gestao"
        alt="Logomarca Click Gestão"
      >
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  data() {
    return {
      flutuation: false,
    };
  },
  methods: {
    updateScroll() {
      if (this.isFlutuation) {
        if (window.scrollY > 120) {
          this.flutuation = true;
        } else {
          this.flutuation = false;
        }
      }
    },
    routerDirect() {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  header
    width: 100%
    height: 700px
    position: relative
    &::before
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 700px
      background: $background-secundary
      -webkit-transform-origin: 0
      transform-origin: 0
      -webkit-transform: skewY(-12deg)
      transform: skewY(-12deg)
      z-index: 1
    .content-box
      overflow: initial !important
      display: flex
      flex-wrap: wrap
      justify-content: center
      z-index: 3
      position: relative
      .logo-click-gestao
        width: 300px
        margin: 0 auto
      .content-header
        width: 100%
        display: flex
        justify-content: space-between
        margin-top: 100px
        img
          width: 40%
        .content-text
          width: 50%
    @media (max-width: $widthTerciarySmall)
      height: auto
      &::before
        height: 100%
      .content-box
        .content-header
          margin-top: 40px
          flex-wrap: wrap
          margin-bottom: 20px
          .content-text
            width: 100%
            margin-bottom: 20px
            h1
              text-align: center
            h4
              text-align: justify
          img
            width: 80%
</style>
